export const STATEMENT_GRID_TRACKS = 'grid grid-cols-[minmax(12rem,1fr)_6rem_8rem_7rem_8rem] gap-x-6';
export const STATEMENT_GRID = `${STATEMENT_GRID_TRACKS} pr-4`;
export const STATEMENT_MIN_WIDTH = 'min-w-[48rem]';
export const LABEL_SPAN_TO_NET = 'col-span-4';
export const LABEL_SPAN_TO_GROSS = 'col-span-2';
